import { Check, Copy } from "lucide-react";
import clsx from "clsx";
import { ACTION_BUTTON_STYLE } from "../constants";

interface Props {
  copied: boolean;
  onCopy: () => void;
}

export const CopyActionButton = ({ copied, onCopy }: Props) => {
  if (copied) {
    return (
      <button className={clsx(ACTION_BUTTON_STYLE, "duration-200 animate-in fade-in zoom-in-95")} disabled>
        <Check size={14} className="mr-1 duration-300 animate-in spin-in-180" />
        Copied
      </button>
    );
  }

  return (
    <button className={ACTION_BUTTON_STYLE} onClick={onCopy}>
      <Copy size={14} className="mr-1" />
      Copy
    </button>
  );
};
